import { render } from "./FormCouple.vue?vue&type=template&id=194ea2ef"
import script from "./FormCouple.vue?vue&type=script&lang=js"
export * from "./FormCouple.vue?vue&type=script&lang=js"

import "./FormCouple.vue?vue&type=style&index=0&id=194ea2ef&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__